<template>
  
  <v-flex xs12 sm12 md12 class="my-5">
    
    <!-- <h3>{{questionText}}</h3> -->

    <v-img v-if="this.uploadedImage" :src="this.uploadedImage" contain class="mb-5"></v-img>
  
    <v-btn 
      block 
      :loading="loading"
      color="blue-grey"
      class="white--text"
      @click.native="openFileDialog"
    >
      Upload
      <v-icon right dark> cloud_upload</v-icon>
    </v-btn>
    <input type="file" id="file-upload" style="display:none" @change="onFileChange">

  </v-flex>

</template>

<script>
// @ is an alias to /src

export default {
  name: "photobox",
  components: {},
  props: {
    question: Object
  },
  data: () => ({
    questionText: null,
    loading: false,
    uploadedImage: null,
    rules: {
      required: value => !!value || 'Cannot Be Empty.'
    },
    selected: null
  }),
  computed: {
  },
  watch: {
    selected() {
      const arg = {
        questionObj : this.question,
        answer : this.selected
      };
      this.$store.commit('setAnswerForQuestionObj', arg);
    }
  },
  created() {
    this.questionText = this.question.text;
  },
  methods: {

    setTextForQuestionObj(text) {
      this.$store.commit('setTextForQuestionObj', {questionObj: this.question, text:text});
    },
    
    openFileDialog() {
      document.getElementById('file-upload').click();
    },
    onFileChange(e) {
      this.loading = true;

      var file = e.target.files || e.dataTransfer.files;

      const fileExt = file[0].type.split("/")[1];
      const filename = this.$uuid.v1() + "." + fileExt;

      var storageRef = firebase.storage().ref();
      var ref = storageRef.child(filename);
      ref.put(file[0])
      .then((snapshot)=> {
        console.log('Uploaded a blob or file!');
        this.loading = false;
        this.selected = filename;
        snapshot.ref.getDownloadURL().then((url)=> {
          this.uploadedImage = url;
        });
      })
      .catch((error)=>{
        console.error(error);
      });

    },
    // uploadFile() {
      // axios.post('URL', self.formData).then(function (response) {
      //   console.log(response);
      // }).catch(function (error) {
      //   console.log(error);
      // });
    // }
  }
};
</script>

<style scoped>

</style>